import { StringMap } from '../common/interfaces/stringMap';

export const routeMappings: StringMap = {
  INIT_TCPLUS_EXPERIENCE: '/link/:linkId',
  INIT_EXPERIENCE: '/start',
  EXPIRED_LINK: '/link-expired',
  INFO: '/info',
  LINK_INVALID: '/link-invalid',

  // Auth
  LOGIN: '/login',
  ACCOUNT: '/account',
  REGISTER: '/register',
  SSO: '/sso',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  USER_PROFILE: '/user-profile',
  DPN: '/dpn',
  RESEARCH_QUESTIONS: '/research-questions',
  APPLICATION_FORM: '/application-form',
  RE_ATTEMPT: '/re-attempt',
  EEO: '/eeo',
  OFCCP: '/ofccp',
  TASK_COMPLETION: '/task-completion',
  YOUR_RESPONSIBILITY: '/your-responsibility',
  CANDIDATE_CONSENT: '/candidate-consent',
  PROCTORING_SETUP: '/proctoring-setup',
  ACCOUNT_LOCKED: '/account-locked',

  // Workflow Items
  GENCONTENT: '/general-content',
  TASKLIST: '/task-list',
  BASICTASKLIST: '/basic-task-list',
  TASKLIST_END: '/end',
  BASICTASKLIST_END: '/basic-task-list/end',
  TASKLIST_HURDLE_FAIL: '/hurdle',
  MFSTASKLIST: '/to-do',
  BIODATA: '/bio-data',
  EXPVIDEOTASK: '/video-task',
  WELCOME: '/welcome',

  // Task Item
  TASK: '/task',
  EXPASSES: '/assessment',
  EXPQUIZ: '/quiz',
  ASSESSMENT_EVALUATION: '/evaluating',

  // Candidate Feedback
  FEEDBACK: '/feedback',
  QUIZ_FEEDBACK: '/feedback',
  VIDEO_FEEDBACK: '/video-feedback',

  // Survey
  TIPS: '/tips',
  MANAGER: '/questions',
  ACCESSIBILITY: '/accessibility',
  START_SURVEY: '/start',
  PREVIEW: '/preview',

  // MFS
  MFS: '/shl360',
  RATERS: '/raters',
  ADD_NEW_RATER: '/new-rater',
  SEARCH_RATER: '/search-rater',
  SEARCH_RESULTS: '/search-results',

  // Not found
  NOT_FOUND: '/not-found',
};

export const backButtonExclusions = [
  routeMappings.INIT_EXPERIENCE,
  routeMappings.SSO,
  routeMappings.FORGOT_PASSWORD,
  routeMappings.USER_PROFILE,
  routeMappings.DPN,
  routeMappings.APPLICATION_FORM,
  routeMappings.RESET_PASSWORD,
  routeMappings.EXPIRED_LINK,
  routeMappings.FEEDBACK,
];
